/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { customInstance } from '../../mutator'
import type { HTTPValidationError, InnerForcesEnvelopeDTO } from '../fastAPI.schemas'

/**
 * @summary Get Inner Forces Envelope
 */
export const getInnerForcesEnvelope = (
  projectGuid: string,
  elementGuid: string,
  signal?: AbortSignal,
) => {
  return customInstance<InnerForcesEnvelopeDTO>({
    url: `/projects/${projectGuid}/inner-forces-envelope/${elementGuid}`,
    method: 'GET',
    signal,
  })
}

export const getGetInnerForcesEnvelopeQueryKey = (projectGuid?: string, elementGuid?: string) => {
  return [`/projects/${projectGuid}/inner-forces-envelope/${elementGuid}`] as const
}

export const getGetInnerForcesEnvelopeQueryOptions = <
  TData = Awaited<ReturnType<typeof getInnerForcesEnvelope>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  elementGuid: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getInnerForcesEnvelope>>, TError, TData>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetInnerForcesEnvelopeQueryKey(projectGuid, elementGuid)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInnerForcesEnvelope>>> = ({ signal }) =>
    getInnerForcesEnvelope(projectGuid, elementGuid, signal)

  return {
    queryKey,
    queryFn,
    enabled: !!(projectGuid && elementGuid),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getInnerForcesEnvelope>>, TError, TData> & {
    queryKey: QueryKey
  }
}

export type GetInnerForcesEnvelopeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInnerForcesEnvelope>>
>
export type GetInnerForcesEnvelopeQueryError = HTTPValidationError

/**
 * @summary Get Inner Forces Envelope
 */

export function useGetInnerForcesEnvelope<
  TData = Awaited<ReturnType<typeof getInnerForcesEnvelope>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  elementGuid: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getInnerForcesEnvelope>>, TError, TData>
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInnerForcesEnvelopeQueryOptions(projectGuid, elementGuid, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}
